import React, {memo} from 'react';
import cn from 'classnames';
import styles from './TextLink.css';

type TextLinkProps = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const TextLink = memo<TextLinkProps>(props => {
	const {className, children, ...nativeProps} = props;

	return (
		<a className={cn(styles.root, className)} {...nativeProps}>
			{children}
		</a>
	);
});

TextLink.displayName = 'TextLink';
